<div class="row justify-content-center">
  <div class="col-lg-auto">
    <label><b>Bewerkingen / opties:</b></label>
  </div>
</div>

<div class="row justify-content-center" *ngIf="errorMessage">
  <br />
  <div class="col-lg-auto mb-1">
    <p class="bewerkingen-error">{{errorMessage}}</p>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-lg-auto mb-1">
    <select [disabled]="selectorDisabled" class="form-select" (change)="onBewerkingSelected($event)">
      <option value="" disabled selected hidden>Selecteer een waarde a.u.b.</option>
      <option *ngFor="let bewerking of bewerkingen" value="{{bewerking.bewerkingCode}}">{{ bewerking.omschrijving }}
      </option>
    </select>
  </div>
</div>
<br />
<div class="row justify-content-center bewerkingen-list-wrapper">
  <ng-container *ngFor="let selection of selectedBwCodes; let i = index">
    <div class="col bg-white py-4 mx-2 my-4 rounded-4 restricted-width">
      <div class="row">
        <bewerkingen-pill [bewerking]="selection" (bewerkingRemoved)="onBewerkingRemoved(i)"></bewerkingen-pill>
      </div>
      <div class="row">
        <div class="col">
          <div *ngIf="shouldShowCustomMeasurements(selection.description)" class="custom-width-wrapper col-lg-auto mb-1">
            <label class="form-label" *ngIf="showKloosterConfiguration(selection.description)">(A) Uit de dagkant:</label>
            <input *ngIf="showKloosterConfiguration(selection.description)" type="number"
              class="form-control" [value]="selection.customOffset"
              (change)="onBewerkingCustomOffsetChanged($event, i)" integerOnly/>
            <label class="form-label"><span
                *ngIf="showKloosterConfiguration(selection.description) || showRenovatieConfiguration(selection.description)">(B)
              </span>Diepte:</label>
            <input type="number" class="form-control" [value]="selection.customDepth"
              (change)="onBewerkingCustomDepthChanged($event, i)" integerOnly/>
            <div class="row justify-content-center" *ngIf="selectedBwErrors[i]?.depth">
              <div class="col-lg-auto mb-1">
                <p class="bewerkingen-error">{{selectedBwErrors[i].depth}}</p>
              </div>
            </div>
            <label class="form-label">
              <span *ngIf="showKloosterConfiguration(selection.description)">(C) </span>
              <span *ngIf="showRenovatieConfiguration(selection.description)">(A) </span>
              Lengte:
            </label>
            <input type="number" class="form-control" [value]="selection.customLength"
              (change)="onBewerkingCustomLengthChanged($event, i)" integerOnly/>
            <label *ngIf="showKloosterConfiguration(selection.description)">(D):</label>
            <input *ngIf="showKloosterConfiguration(selection.description)" type="number"
              class="form-control form-control-sm" [disabled]="true"
              [value]="neutLengte - selection.customOffset - selection.customLength" />
            <div class="row justify-content-center" *ngIf="selectedBwErrors[i]?.overflow">
              <div class="col-lg-auto mb-1">
                <p class="bewerkingen-error">{{selectedBwErrors[i].overflow}}</p>
              </div>
            </div>
          </div>
          <div *ngIf="shouldShowVerstekOption(selection.description)" class="custom-width-wrapper">
            <label class="form-label">Oriëntatie:</label>
            <select class="form-control" [(ngModel)]="selection.orientatie"
              (change)="onVerstekOrentatieChange($event, i)">
              <option value="naarBuiten" [selected]="selection.orientatie === 'naarBuiten'">Naar buiten</option>
              <option value="naarBinnen" [selected]="selection.orientatie === 'naarBinnen'">Naar binnen</option>
            </select>
          </div>
          <div *ngIf="shouldShowVerstekNeutCutOption(selection.description, i)" class="custom-width-wrapper"
            id="neutCutWrapper">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="selection.cutNeut"
              (change)="onCutNeutChanged($event, i)" id="neutCut">
              <label class="form-check-label" for="neutCut" id="neutCutLabel">
                Neut laten doorlopen in verstek
              </label>
            </div>
          </div>
        </div>
        <div class="col justify-content-center" *ngIf="showKloosterConfiguration(selection.description) || showRenovatieConfiguration(selection.description)">
            <img src="/assets/tooltip-assets/kloostersponning.png" alt="Kloostersponning example" *ngIf="showKloosterConfiguration(selection.description)">
            <img src="/assets/tooltip-assets/renovatiesponning.png" alt="Renovatiesponning example" *ngIf="showRenovatieConfiguration(selection.description)">
        </div>
      </div>
      
    </div>
  </ng-container>
</div>